import React from 'react'
import { Button } from '../../ui/button'
import { HelpCircle } from 'lucide-react'
import { ProgressIndicator } from './progress-indicator'

interface SurveyHeaderProps {
  currentSection: number
  sectionName: string
  progress: number
  onShowTips: () => void
  onBackToInstructions: () => void
  questionNumber?: number
  totalQuestionsInSection?: number
}

export function SurveyHeader({
  currentSection,
  sectionName,
  progress,
  onShowTips,
  onBackToInstructions,
  questionNumber,
  totalQuestionsInSection
}: SurveyHeaderProps) {
  return (
    <div className="space-y-2">
      <div className="flex flex-col gap-2">
        <div className="space-y-2">
          <h2 className="text-lg font-medium">
            Section {currentSection + 1}: {sectionName}
          </h2>
          {questionNumber !== undefined && totalQuestionsInSection !== undefined && (
            <p className="text-sm text-muted-foreground">
              Question {questionNumber} of {totalQuestionsInSection}
            </p>
          )}
        </div>
        <div className="flex justify-between w-full">
          <Button
            variant="ghost"
            onClick={onBackToInstructions}
          >
            Back to Instructions
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onShowTips}
          >
            <HelpCircle className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <ProgressIndicator
        currentSection={currentSection}
        sectionName={sectionName}
        progress={progress}
        onShowTips={onShowTips}
      />
    </div>
  )
}